module.exports = __webpack_public_path__ + "static/media/cert_85.e7297eaf.jpg";